module.exports = __webpack_public_path__ + "static/img/1053_big.2858d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1053_big.png
// module id = y0aX
// module chunks = 1